import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { StyledMultiMediaButton } from './Styles';
import Media from '../../../../_shared/models/Media';
import TradeDetails from '../../../../_shared/models/TradeDetails';
import useTrackMultiMediaGallery from '../../../../_shared/hooks/useTrackMultiMediaGallery';
import segmentConfig from '../../../../_shared/constants/segmentConfig';

const propTypes = {
  mediaList: PropTypes.instanceOf(Media),
  setOverlayOpen: PropTypes.func,
  tradeDetails: PropTypes.instanceOf(TradeDetails),
  inBigImageContainer: PropTypes.bool
};

const defaultProps = {
  mediaList: undefined,
  setOverlayOpen: undefined,
  tradeDetails: undefined,
  inBigImageContainer: undefined
};

const MultiMediaButton = ({
  mediaList,
  setOverlayOpen,
  tradeDetails,
  inBigImageContainer,
  tradeContext,
  tradeState
}) => {
  const trackMultiMediaGallery = useTrackMultiMediaGallery();

  const openOverlay = () => {
    setOverlayOpen(true);

    trackMultiMediaGallery({
      tradeDetails,
      tradeState,
      mediaList,
      tradeContext,
      galleryOpenType: segmentConfig.galleryOpenType.button
    });
  };

  return (
    <StyledMultiMediaButton
      id="vdp-openmultimedia"
      testId="vdpMultimedia"
      onClick={openOverlay}
      inBigImageContainer={inBigImageContainer}
    >
      <FormattedMessage id="vdp.overview.media.open" />
    </StyledMultiMediaButton>
  );
};

MultiMediaButton.propTypes = propTypes;
MultiMediaButton.defaultProps = defaultProps;

export default MultiMediaButton;
